import axios from './axios';

export const getRamsRecords = ({ params } = {}) => axios.get(`rams_records`, { params });
export const getRamsRecord = ({ params, id } = {}) => axios.get(`rams_records/${id}`, { params });
export const createRamsRecord = ({ data }) => axios.post(`rams_records`, data);
export const updateRamsRecord = ({ id, data }) => axios.post(`rams_records/${id}`, data);
export const deleteRamsRecord = ({ id }) => axios.delete(`rams_records/${id}`);
export const sendRamsForApproval = (id) => axios.post(`rams_records/${id}/send-for-approval`);
export const approveRamsRecord = (id, data) => axios.post(`rams_records/${id}/approve`, data);
export const expireRamsRecord = (id) => axios.post(`rams_records/${id}/expire`);